<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div>
        <v-tour name="myTour" :steps="steps" :options="myOptions"></v-tour>
        <v-tour
          name="myTourPage"
          :steps="stepsPage"
          :options="myOptionsPage"
        ></v-tour>
        <v-breadcrumbs
          class="pb-7"
          :items="breadcrumbs"
          id="v-step-2"
          divider=">"
        ></v-breadcrumbs>
        <v-row justify="center" style="border-top: solid #d0cfcf;">
          <!-- Dialog export / import -->
          <!-- <v-col cols="12">
            <v-btn color="primary" depressed @click="dialogAdd = true">
              <v-icon left>mdi-text-box-plus</v-icon>
              Add
            </v-btn>
          </v-col> -->
          <!-- ADD -->
          <v-dialog v-model="dialogAdd" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">เพิ่มข้อมูล</span>
                <v-spacer></v-spacer>
                <v-checkbox
                  v-model="canvas"
                  label="เปิด / ปิด Canvas"
                ></v-checkbox>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row style="height: 50px">
                    <v-col cols="6">
                      <v-alert
                        :color="formAdd.color1"
                        dense
                        icon="mdi-alpha-h-box"
                        type="success"
                        border="bottom"
                        >Headline</v-alert
                      >
                    </v-col>
                    <v-col cols="6">
                      <v-alert
                        :color="formAdd.color2"
                        dense
                        icon="mdi-alpha-i-box"
                        type="success"
                        border="bottom"
                        >Icon</v-alert
                      >
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" class="d-flex justify-center">
                      <v-color-picker
                        :hide-canvas="!canvas"
                        mode="hexa"
                        hide-mode-switch
                        v-model="formAdd.color1"
                      ></v-color-picker>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-center">
                      <v-color-picker
                        :hide-canvas="!canvas"
                        mode="hexa"
                        hide-mode-switch
                        v-model="formAdd.color2"
                      ></v-color-picker>
                    </v-col>
                  </v-row>
                  <v-row style="height: 50px">
                    <v-col cols="6">
                      <v-alert
                        :color="formAdd.color3"
                        dense
                        icon="mdi-alpha-s-box"
                        type="success"
                        border="bottom"
                        >Sub-headline</v-alert
                      >
                    </v-col>
                    <v-col cols="6">
                      <v-alert
                        :color="formAdd.color4"
                        dense
                        icon="mdi-format-header-2"
                        type="success"
                        border="bottom"
                        >Headline 2</v-alert
                      >
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" class="d-flex justify-center">
                      <v-color-picker
                        :hide-canvas="!canvas"
                        mode="hexa"
                        hide-mode-switch
                        v-model="formAdd.color3"
                      ></v-color-picker>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-center">
                      <v-color-picker
                        :hide-canvas="!canvas"
                        mode="hexa"
                        hide-mode-switch
                        v-model="formAdd.color4"
                      ></v-color-picker>
                    </v-col>
                  </v-row>
                  <v-row style="height: 50px">
                    <v-col cols="6">
                      <v-alert
                        :color="formAdd.color5"
                        dense
                        icon="mdi-alpha-s-box-outline"
                        type="success"
                        border="bottom"
                        >Sub-headline 2</v-alert
                      >
                    </v-col>
                    <v-col cols="6">
                      <v-alert
                        :color="formAdd.color6"
                        dense
                        icon="mdi-alpha-i-box-outline"
                        type="success"
                        border="bottom"
                        >lcon 2</v-alert
                      >
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" class="d-flex justify-center">
                      <v-color-picker
                        :hide-canvas="!canvas"
                        mode="hexa"
                        hide-mode-switch
                        v-model="formAdd.color5"
                      ></v-color-picker>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-center">
                      <v-color-picker
                        :hide-canvas="!canvas"
                        mode="hexa"
                        hide-mode-switch
                        v-model="formAdd.color6"
                      ></v-color-picker>
                    </v-col>
                  </v-row>
                  <v-row style="height: 50px">
                    <v-col cols="6">
                      <v-alert
                        :color="formAdd.color7"
                        dense
                        icon="mdi-alpha-p-box"
                        type="success"
                        border="bottom"
                        >Picture</v-alert
                      >
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" class="d-flex justify-center">
                      <v-color-picker
                        :hide-canvas="!canvas"
                        mode="hexa"
                        hide-mode-switch
                        v-model="formAdd.color7"
                      ></v-color-picker>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="dark darken-1"
                  @click=";(dialogAdd = false), clearData()"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn elevation="2" x-large color="success" @click="addData()">
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  เพิ่ม
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="50%">
            <!-- <v-card>
              <v-card-title id="v-step-1">
                <span class="headline">แก้ไขข้อมูล</span>
                <v-spacer></v-spacer>
                <v-checkbox
                  v-model="canvas"
                  label="เปิด / ปิด Canvas"
                ></v-checkbox>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row style="height: 50px">
                    <v-spacer></v-spacer>
                    <v-col cols="6">
                      <v-alert
                        :color="formUpdate.color1"
                        dense
                        icon="mdi-alpha-h-box"
                        type="success"
                        border="bottom"
                        >Headline</v-alert
                      >
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="6" class="d-flex justify-center">
                      <v-color-picker
                        :hide-canvas="!canvas"
                        mode="hexa"
                        hide-mode-switch
                        v-model="formUpdate.color1"
                      ></v-color-picker>
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  dark
                  x-large
                  class="btn-color"
                  @click="dialogEdit = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="success"
                  @click="editData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  แก้ไข
                </v-btn>
              </v-card-actions>
            </v-card> -->
          </v-dialog>
          <!-- end edit -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="รหัส สี*"
                        v-model="formUpdate.colorId"
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="red darken-1"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->
          <!-- data table -->
          <v-col :cols="resCol2" style="align-items: center;justify-content: center;display: flex">
             <!-- <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular> -->
            <div style="width:390px" v-if="showEditAndExample">
              <v-card-text>
                <p style="font-size: 25px;padding-left: 10px;"><v-icon class="iconify mr-3" data-icon="noto:pencil"></v-icon> ปรับแต่งสีธีมร้าน</p>
                <v-container style="border: solid #d7d2d2;border-radius: 20px;background-color: #d5d5d55e;" class="pa-5">
                  <div id="v-step-1">
                    <v-spacer></v-spacer>
                    <v-checkbox
                      class="mt-0"
                      v-model="canvas"
                      label="เปิด / ปิด Canvas"
                    ></v-checkbox>
                  </div>
                  <v-row style="height: 50px;justify-content: center">
                    <!-- <v-spacer></v-spacer> -->
                    <v-col cols="12" style="">
                      <v-alert
                        :color="formUpdate.color1"
                        dense
                        type="success"
                        border="bottom"
                        >ธีมร้าน</v-alert
                      >
                    </v-col>
                    <!-- <v-spacer></v-spacer> -->
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="d-flex justify-center">
                      <v-color-picker
                        :hide-canvas="!canvas"
                        mode="hexa"
                        hide-mode-switch
                        v-model="formUpdate.color1"
                      ></v-color-picker>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions style="justify-content: center;">
                <v-btn
                  elevation="0"
                  large
                  block
                  :loading="loading"
                  :disabled="disabled"
                  color="success"
                  @click="editData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  บันทึก
                </v-btn>
              </v-card-actions>
            </div>
            <!-- <v-card elevation="7" v-if="dataReady">
              <v-card-title> </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  dense
                  :items-per-page="10"
                >
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ thaiFormattedDate(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ thaiFormattedDate(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.color1`]="{ item }">
                    <span
                      class="div_color"
                      :style="'background-color:' + item.color1"
                    ></span>
                  </template>
                  <template v-slot:[`item.color2`]="{ item }">
                    <span
                      class="div_color"
                      :style="'background-color:' + item.color2"
                    ></span>
                  </template>
                  <template v-slot:[`item.color3`]="{ item }">
                    <span
                      class="div_color"
                      :style="'background-color:' + item.color3"
                    ></span>
                  </template>
                  <template v-slot:[`item.color4`]="{ item }">
                    <span
                      class="div_color"
                      :style="'background-color:' + item.color4"
                    ></span>
                  </template>
                  <template v-slot:[`item.color5`]="{ item }">
                    <span
                      class="div_color"
                      :style="'background-color:' + item.color5"
                    ></span>
                  </template>
                  <template v-slot:[`item.color6`]="{ item }">
                    <span
                      class="div_color"
                      :style="'background-color:' + item.color6"
                    ></span>
                  </template>
                  <template v-slot:[`item.color7`]="{ item }">
                    <span
                      class="div_color"
                      :style="'background-color:' + item.color7"
                    ></span>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          id="v-step-0"
                          x-small
                          @click.stop=";(dialogEdit = true), getDataById(item)"
                        >
                          <v-icon dark> mdi-tools </v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card> -->
            <!-- <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div> -->
          </v-col>
<!-- v-if="showEditAndExample" -->
          <v-col :cols="resCol"  class="pt-5" :style="showEditAndExample == false ? 'height: 77vh;align-items: center;display: flex;' : 'none'">
            <v-progress-circular
                indeterminate
                color="primary"
                v-if="!showEditAndExample"
              ></v-progress-circular>
            <div style="justify-content: center;display: flex;" v-if="showEditAndExample">
                <!-- <p style="font-size: 25px;padding-left: 10px;" class="mb-2">* ตัวอย่างบัตรสมาชิกลูกค้า</p> -->
              <div style="border-radius: 10px;min-width: 70%;min-height: 746px;border: solid #c6c0c0 2px;position: relative;" >
                <div fluid class="pa-0">
                  <div class="pa-4" :style="'border-top-right-radius: 8px;border-top-left-radius: 8px;z-index: 0;position: relative;min-height:150px;background-image: linear-gradient(0deg,' +  bgColor + '0%,' +  bgColor2 + '100%);'">
                    <div :style="'height: 93px;background-color:' +  bgColor2 + ';width: 162px;border-bottom-right-radius: 110px;border-bottom-left-radius: 110px;position: absolute;z-index: -1;right: 14px;top: 0px;'"></div>
                    <div :style="'height: 90px;background-color:' +  bgColor2 + ';width: 45px;border-top-left-radius: 110px;border-bottom-left-radius: 110px;position: absolute;z-index: -1;right: 1px;top: 29px;'"></div>
                    <div :style="'height: 89px;background-color:' +  bgColor3 + ';width: 89px;border-radius: 100px;position: absolute;z-index: -1;right: 17px;top: 58px;'"></div>
                    <div :style="'height: 89px;background-color:' +  bgColor3 + ';width: 89px;border-radius: 100px;position: absolute;z-index: -1;right: 73px;top: 70px;'"></div>
                    <div style="display:flex;justify-content: space-between;z-index: 1;">
                      <p :style="'color:' +  textcolor + ';margin-bottom:4px'">
                        👋 ยินดีต้อนรับ
                      </p>
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              style="
                                font-size: 26px;
                              "
                              large
                              :color=" textcolor"
                            >
                              mdi-bell-ring-outline
                            </v-icon>
                    </div>
                    <div style="display:flex;">
                      <div style="align-items: center;display: flex;">
                          <v-btn icon x-large style="display: contents;">
                            <img
                              style="
                                border-color: white;
                                height: 50px;
                                border-radius: 40px;
                                border-style: solid;
                                border-width: 1px;
                                box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
                                margin-right:6px;
                              "
                              alt="Avatar"
                              :src="require('@/assets/notify.png')"
                            />
                          </v-btn>
                      </div>
                      <div>
                        <p :style="'color:' +  textcolor + ';margin-bottom:0px;display:flex;align-items: center;margin-bottom:5px'">
                        คุณโอเค
                        <v-icon style="font-size:20px;margin-left:6px;" :color=" textcolor">mdi-check-decagram</v-icon>
                        </p>
                        <div @click="overlay = true,adddataToEditData()" v-bind="attrs" v-on="on" small class="mb-0 pl-2 pr-1" style="font-size: 13px;background-color: #aeaaaa;color: white;border-radius: 19px;">
                              รายละเอียดสมาชิก
                              <v-icon style="font-size:20px;margin-left:2px" color="white">mdi-chevron-down</v-icon>
                              </div>
                      </div>
                    </div>
                    <v-row class="mt-2">
                      <v-col cols="4" class="pa-4 pr-2">
                        <v-card style="padding: 8px;border-radius: 13px;position: relative;" elevation="0">
                          <!-- <div :style="'height: 40px;background-color:' +  bgColor3 + ';width: 40px;border-radius: 100px;position: absolute;z-index: 2;right: 55px;top: 5px;'"></div> -->
                          <!-- <p class="mb-0" style="font-size: 20px;font-weight: bold;"> {{ formatNumber(newData.currentPoint) }} </p> -->
                          <div :color=" bgColor3" style="font-size: 20px;font-weight: bold;display: flex;justify-content: space-between;flex-wrap: wrap;">
                            <p class="mb-0" :style="'color:' + bgColor">100</p>
                            <img
                                style="
                                  border-color: white;
                                  height: 25px;
                                "
                                alt="Avatar"
                                :src="require('@/assets/coin.png')"
                              />
                          </div>
                          <p class="mb-0" style="font-size: 13px;">คะแนนปัจจุบัน</p>
                        </v-card>
                      </v-col>
                      <v-col cols="4" class="pa-4 pr-2">
                        <v-card style="padding: 8px;border-radius: 13px;position: relative;" elevation="0">
                          <!-- <div :style="'height: 40px;background-color:' +  bgColor3 + ';width: 40px;border-radius: 100px;position: absolute;z-index: 2;right: 1px;top: 25px;'"></div> -->
                            <div :color=" bgColor3" style="font-size: 20px;font-weight: bold;display: flex;justify-content: space-between;"  @click=" router.push('/NewMyReward').catch(()=>{})">
                              <p class="mb-0" :style="'color:' + bgColor">0</p>
                              <img
                                style="
                                  border-color: white;
                                  height: 25px;
                                "
                                alt="Avatar"
                                :src="require('@/assets/gift.png')"
                              />
                            </div>
                          <p class="mb-0" style="font-size: 13px;">รางวัลของฉัน</p>
                        </v-card>
                      </v-col>
                      <v-col cols="4" class="pa-4 pr-2">
                        <v-card style="padding: 8px;border-radius: 13px;position: relative;" elevation="0">
                          <!-- <div :style="'height: 40px;background-color:' +  bgColor3 + ';width: 40px;border-radius: 100px;position: absolute;z-index: 2;right: 1px;top: 25px;'"></div> -->
                          <div :color=" bgColor3" style="font-size: 20px;font-weight: bold;display: flex;justify-content: space-between;">
                              <p class="mb-0" :style="'color:' + bgColor">0</p>
                              <img
                              style="
                                border-color: white;
                                height: 27px;
                              "
                              alt="Avatar"
                              :src="require('@/assets/package.png')"
                              />
                          </div>
                          <p class="mb-0" style="font-size: 13px;">แพ็กเกจ</p>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </div>
                <!-- example promotion -->
                <section style="background-color: white;">
                  <div  :style="';height:50px;width:100%;border-radius: 0px;background-image: linear-gradient(179deg,' + bgColor + '0%,' + bgColor2 + '100%);'">
                    <v-row no-gutters>
                  <v-col class="pl-4 font18 pt-3" style="color: white; display: flex"
                    ><div
                      class="pb-0 mr-3"
                      :style="
                        'color:' + textcolor + ' ;font-weight: bold;'
                      "
                    >
                      โปรโมชั่น
                    </div>
                    <v-icon class="iconify" data-icon="fxemoji:megaphone"></v-icon
                  ></v-col>
                  <v-col
                    class="text-end pr-3 font14 link pt-3"
                    :style="'color:' + textcolor + ';justify-content: flex-end;align-items: center;display: flex;'"
                    >ดูทั้งหมด
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-col>
                </v-row>
                  </div>
                  <div>
                    <div
                      class="mx-auto"
                      max-width="1600"
                      style="display: flex; justify-content: center;background-color: white;"
                      :style="';margin-top:10px;'"
                    >
                      <div
                        class="ma-4"
                        width="270"
                        height="180"
                        style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          height: 130px;
                        "
                      >
                        <div style="color: #808588ff; font-size: 20px; font-weight: bold">
                          ติดตามโปรโมชั่นน่าสนใจได้ที่นี่
                          <v-icon
                            style="margin-bottom: 9px;"
                            class="iconify"
                            data-icon="fluent:megaphone-loud-24-filled"
                          ></v-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section style="background-color: white;">
                  <div :style="'box-shadow: 0 5px 5px 0px ' + bgColor2 + ';height:50px;width:100%; border-bottom-left-radius: 0px; border-bottom-right-radius: 0px;background-image: linear-gradient(180deg,' + bgColor + '0%,' + bgColor2 + '100%);'">
                    <v-row no-gutters>
                      <v-col class="pl-4 font18 pt-3" style="display:flex;"><div :style="'color:' + textcolor + ';font-weight: bold;'"
                      class="pb-0 mr-3">ของรางวัล</div>  <v-icon class="iconify" data-icon="noto:wrapped-gift"></v-icon></v-col>
                  <v-col
                    class="text-end pr-2 font14 link pt-3"
                    :style="'color:' + textcolor + ';justify-content: flex-end;align-items: center;display: flex;'"
                    >ดูทั้งหมด <v-icon>mdi-chevron-right</v-icon>
                  </v-col>
                </v-row>
                  </div>
                    <div
                      class="mx-auto"
                      max-width="1600"
                      style="display: flex; justify-content: center;background-color: white;"
                      :style="';margin-top:10px;'"
                    >
                      <div
                        class="ma-4"
                        width="270"
                        height="180"
                        style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          height: 130px;
                        "
                      >
                        <div style="color: #808588ff; font-size: 20px; font-weight: bold">
                          ติดตามของรางวัลได้ที่นี่
                          <v-icon
                            style="margin-bottom: 9px;"
                            class="iconify"
                            data-icon="fluent:megaphone-loud-24-filled"
                          ></v-icon>
                        </div>
                      </div>
                    </div>
                </section>

                <div app padless >
                  <v-card
                      width="100%"
                      style="padding: 10px;position: absolute;
    bottom: 0px;"
                    >
                      <v-card-text style="display: flex;
                  justify-content: space-around;padding: 0px !important;">
                        <v-btn icon id="no-background-hover">
                          <div style="flex-direction: row ;">
                            <div>
                                <v-icon size="29px">
                                  mdi-home
                                </v-icon>
                            </div >
                              <p style="margin-bottom: 0;letter-spacing: 0px;">
                                หน้าหลัก
                              </p>
                          </div>
                        </v-btn>

                        <v-btn icon id="no-background-hover">
                            <div style="flex-direction: row ;">
                              <div>
                                  <v-icon size="29px">
                                    mdi-account-circle
                                  </v-icon>
                              </div>
                                <p style="margin-bottom: 0;letter-spacing: 0px;">
                                  บัญชี
                                </p>
                            </div>
                        </v-btn>

                        <v-btn icon id="no-background-hover">
                          <div style="flex-direction: row ;">
                            <div>
                              <v-icon size="24px">
                                mdi-gift
                              </v-icon>
                            </div>
                              <p style="margin-bottom: 0;letter-spacing: 0px;">
                                กิจกรรม
                              </p>
                          </div>
                        </v-btn>

                        <v-btn  icon id="no-background-hover">
                          <div style="flex-direction: row ;" >
                            <div>
                              <v-icon size="29px">
                                mdi-store
                              </v-icon>
                            </div>
                              <p style="margin-bottom: 0;letter-spacing: 0px;">
                                ข้อมูลติดต่อ
                              </p>
                          </div>
                        </v-btn>
                      </v-card-text>
                    </v-card>
                </div>
              </div>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
// import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
// import XLSX from 'xlsx' // import xlsx
// import readXlsxFile from 'read-excel-file'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu
    // downloadExcel: JsonExcel,
    // XLSX,
    // readXlsxFile
  },
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    },
    resCol2 () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '5'
        case 'lg':
          return '5'
        case 'xl':
          return '5'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  created () {
    // setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      myOptionsPage: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'ข้ามการแนะนำ',
          buttonPrevious: 'ย้อนกลับ',
          buttonNext: 'ต่อไป',
          buttonStop: 'จบการแนะนำ'
        }
      },
      stepsPage: [
        {
          target: '#v-step-0',
          header: {
            title: 'เริ่มต้นการแก้ไข Theme'
          },
          content: 'กดปุ่มแก้ไข <strong>Theme</strong>',
          params: {
            highlight: true
          },
          before: type =>
            new Promise((resolve, reject) => {
              // Time-consuming UI/async operation here
              resolve((this.dialogAdd = false), (this.dialogEdit = false))
            })
        },
        {
          target: '#v-step-1',
          content: 'เลือก Theme ต้องการ แล้วกด <strong>แก้ไข</strong>',
          params: {
            highlight: true
          },
          before: type =>
            new Promise((resolve, reject) => {
              // Time-consuming UI/async operation here
              resolve((this.dialogEdit = true))
            })
        },
        {
          target: '#v-step-2',
          content: '<strong>จบการแนะนำ</strong><br>ขอบคุณครับ',
          params: {
            highlight: true
          },
          before: type =>
            new Promise((resolve, reject) => {
              // Time-consuming UI/async operation here
              resolve((this.dialogEdit = false))
            })
        }
      ],
      myOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'ข้ามการแนะนำ',
          buttonPrevious: 'ย้อนกลับ',
          buttonNext: 'ต่อไป',
          buttonStop: 'จบการแนะนำและนำไปการจัดการ Theme'
        }
      },
      steps: [
        {
          target: '#v-step-0',
          header: {
            title: 'เริ่มต้นการแก้ไข Theme'
          },
          content: 'กดปุ่มแก้ไข <strong>Theme</strong>',
          params: {
            highlight: true
          },
          before: type =>
            new Promise((resolve, reject) => {
              // Time-consuming UI/async operation here
              resolve((this.dialogAdd = false), (this.dialogEdit = false))
            })
        },
        {
          target: '#v-step-1',
          content: 'เลือก Theme ต้องการ แล้วกด <strong>แก้ไข</strong>',
          params: {
            highlight: true
          },
          before: type =>
            new Promise((resolve, reject) => {
              // Time-consuming UI/async operation here
              resolve((this.dialogEdit = true))
            })
        },
        {
          target: '#v-step-2',
          params: {
            highlight: true
          },
          before: type =>
            new Promise((resolve, reject) => {
              // Time-consuming UI/async operation here
              resolve(
                (this.dialogEdit = false),
                this.$router.push('/Master/Level?tour=true')
              )
            })
        }
      ],
      PK: '',
      path: '/color/', // Path Model
      returnLink: '/Master/Color',
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'ธีมร้านค้า',
          disabled: false,
          href: '/Master/Color'
        }
      ],
      // End Menu Config
      dataReady: true,
      canvas: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      code: 'AGE_', // Generate Code
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      formAdd: {
        color1: '',
        color2: '',
        color3: '',
        color4: '',
        color5: '',
        color6: '',
        color7: '',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: this.$session.getAll().data.shopId
      },
      formUpdate: {
        colorId: '',
        color1: '',
        color2: '',
        color3: '',
        color4: '',
        color5: '',
        color6: '',
        color7: '',
        LAST_USER: '',
        shopId: ''
      },
      nameRules: [
        v => !!v || 'Name is required',
        v => v.length <= 50 || 'Name must be less than 50 characters'
      ],
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'ID', value: 'colorId' },
        { text: 'ธีมสี', value: 'color1' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      bgColor: null,
      bgColor2: null,
      bgColor3: null,
      textcolor: null,
      loading: false,
      disabled: false,
      showEditAndExample: false
      // End Data Table Config
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  watch: {
    'formUpdate.color1': function (val) {
      if (val) {
        this.calColor(val)
      }
    }
  },
  async mounted () {
    // this.getGetToken(this.DNS_IP)
    this.loading = false
    // Get Data
    await this.getDataGlobal(
      this.DNS_IP,
      this.path,
      this.session.data.shopId,
      this.returnLink
    )
    // console.log('this.formUpdate.color1', this.formUpdate.color1)
    // this.calColor(this.formUpdate.color1.slice(0, -2))
    await this.getDataById(this.dataItem[0].colorId)
    console.log('dataItem', this.dataItem)
    this.calColor(this.formUpdate.color1)

    setTimeout(() => {
      this.showEditAndExample = true
    }, 1500)
  },
  methods: {
    async searchDataAll () {
      var search =
        '?colorId=' +
        this.searchAll +
        '&color1=' +
        this.searchAll +
        '&color2=' +
        this.searchAll +
        '&color3=' +
        this.searchAll +
        '&color4=' +
        this.searchAll +
        '&color5=' +
        this.searchAll +
        '&color6=' +
        this.searchAll +
        '&color7=' +
        this.searchAll
      this.loading = false
      this.searchDataAllGlobal(this.DNS_IP, this.path, search, this.returnLink)
    },
    async getDataById (item) {
      this.loading = false
      this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'colorId',
        item,
        this.returnLink
      )
    },
    async addData () {
      this.loading = false

      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.formAdd.CREATE_USER = this.session.data.userName
          this.formAdd.LAST_USER = this.session.data.userName
          await axios
            .post(
              this.DNS_IP + this.path + 'add',
              this.formAdd
            )
            .then(async response => {
              // Debug response
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)

              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogAdd = false

              // Load Data
              await this.clearData()
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              console.log('error function addDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              this.loading = true
            })
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.loading = true
        })
    },
    async editData () {
      // this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItem)
      this.disabled = true
      this.loading = true

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          console.log('this.formUpdate', this.formUpdate)
          this.formUpdate.LAST_USER = this.session.data.userName
          var ID = this.formUpdate.colorId
          delete this.formUpdate['colorId']
          delete this.formUpdate['LAST_DATE']
          delete this.formUpdate['CREATE_DATE']
          delete this.formUpdate['name']
          delete this.formUpdate['logo']
          delete this.formUpdate['importData']
          delete this.formUpdate['otpConfirm']
          delete this.formUpdate['barCodeData']
          delete this.formUpdate['loyverseStatus']
          delete this.formUpdate['friendGetFriendStatus']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + 'edit/' + ID,
              this.formUpdate
              , {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async response => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false

              // Load Data
              // await this.reloadData()
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              await this.getDataById(this.dataItem[0].colorId)
              this.loading = false
              this.disabled = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.loading = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch(error => {
          this.loading = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('DELETE PK : ', this.formUpdate.colorId)
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      // this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      this.loading = false
      this.deleteDataGlobal(
        this.DNS_IP,
        this.path,
        this.formUpdate.colorId,
        this.session.data.shopId,
        this.returnLink
      )
    },
    async clearData () {
      // eslint-disable-next-line no-redeclare
      for (var key in this.formAdd) {
        if (this.formAdd[key]) {
          this.formAdd[key] = ''
        }
      }

      // eslint-disable-next-line no-redeclare
      // for (var key in this.search) {
      //   if (this.search[key]) {
      //     this.search[key] = ''
      //   }
      // }
    },
    calColor (item) {
      console.log(item)
      this.textcolor = this.HEXToVBColor(item)
      this.bgColor = this.hexToRgbA(item.slice(0, -2))
      this.bgColor2 = this.calBgColor2(this.bgColor)
      this.bgColor3 = this.calBgColor3(this.bgColor2)
    },
    // calColorMounted (item) {

    // }
    hexToRgbA (hex) {
      var c
      // if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('')
      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]]
      }
      c = '0x' + c.join('')
      return 'rgb(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ')'
      // }
      // throw new Error('Bad Hex')
    },
    calBgColor2 (rgb) {
      console.log('rgb', rgb)
      var c = rgb.slice(3).slice(1, -1).split(',')
      console.log('ddddds', c)
      return 'rgb(' + (parseInt(c[0]) + 50) + ',' + (parseInt(c[1]) + 50) + ',' + (parseInt(c[2]) + 50) + ')'
    },
    calBgColor3 (rgb) {
      console.log('rgb', rgb)
      var c = rgb.slice(3).slice(1, -1).split(',')
      console.log('ddddds', c)
      return 'rgb(' + (parseInt(c[0]) + 50) + ',' + (parseInt(c[1]) + 50) + ',' + (parseInt(c[2]) + 50) + ', 0.3)'
    },
    HEXToVBColor (a) {
      let rr = parseInt(a.substr(1, 2), 16)
      let gg = parseInt(a.substr(3, 2), 16)
      let bb = parseInt(a.substr(5, 2), 16)

      console.log('rrrr', rr * 0.299 + gg * 0.587 + bb * 0.114)
      if (rr * 0.299 + gg * 0.587 + bb * 0.114 > 186) {
        let black = 'rgb(121 105 105)'
        return black
      } else {
        let white = '#ffffff'
        return white
      }
    }
  }
}
</script>
<style scoped>
.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.4);
}
.div_color {
  width: 65px;
  height: 65px;
  display: block;
  border-radius: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/Master/Color.vue